import { render, staticRenderFns } from "./listCheck.vue?vue&type=template&id=2a865fca&scoped=true&"
import script from "./listCheck.vue?vue&type=script&lang=js&"
export * from "./listCheck.vue?vue&type=script&lang=js&"
import style0 from "./listCheck.vue?vue&type=style&index=0&id=2a865fca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a865fca",
  null
  
)

export default component.exports